import * as actionTypes from './actionTypes';
import axios from '../../global/axios';

export const convertFileStart = () => {
    return {
        type: actionTypes.CONVERT_FILE_START
    };
};

export const convertFileSuccess = (blob, filename) => {
    return {
        type: actionTypes.CONVERT_FILE_SUCCESS,
        blob: blob,
        filename: filename
    };
};

export const convertFileDebugSuccess = (debugJson) => {
    return {
        type: actionTypes.CONVERT_FILE_DEBUG_SUCCESS,
        debugJson: debugJson
    };
};

export const convertFileFailure = (error) => {
    return {
        type: actionTypes.CONVERT_FILE_FAILURE,
        error: error
    };
};

export const convertFileReset = () => {
    return {
        type: actionTypes.CONVERT_FILE_RESET
    };
};

export const convertFile = (file, debug = false) => {
    return dispatch => {
        dispatch(convertFileStart());

        const formData = new FormData();
        formData.append('file', file);
        if (debug) {
            formData.append('debug', '1');
        }

        axios.post('/slides/converter/convert', formData, {
            responseType: debug ? 'json' : 'blob'
        })
        .then(res => {
            if (debug) {
                dispatch(convertFileDebugSuccess(res.data));
            } else {
                const disposition = res.headers['content-disposition'];
                let filename = file.name.replace(/\.[^/.]+$/, '') + '.proBundle';
                if (disposition) {
                    const match = disposition.match(/filename="?([^";\n]+)"?/);
                    if (match) {
                        filename = match[1];
                    }
                }
                dispatch(convertFileSuccess(res.data, filename));
            }
        })
        .catch(err => {
            let message = 'Conversion failed';
            if (err.response && err.response.data) {
                if (debug) {
                    dispatch(convertFileFailure(err.response.data.error || message));
                } else {
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const json = JSON.parse(reader.result);
                            dispatch(convertFileFailure(json.error || message));
                        } catch (e) {
                            dispatch(convertFileFailure(message));
                        }
                    };
                    reader.onerror = () => {
                        dispatch(convertFileFailure(message));
                    };
                    reader.readAsText(err.response.data);
                }
            } else {
                dispatch(convertFileFailure(err.message || message));
            }
        });
    };
};
